import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { getClosestOfKeys, sizeToPixelSort } from "./utils";
export var AdaptiveProjection = /*#__PURE__*/function () {
  function AdaptiveProjection(value, params) {
    _classCallCheck(this, AdaptiveProjection);
    this.value = value;
    this.params = params;
  }
  _createClass(AdaptiveProjection, [{
    key: "getSortedKeys",
    value: function getSortedKeys() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.value;
      return Object.keys(value).sort(sizeToPixelSort);
    }
  }, {
    key: "getClosestKey",
    value: function getClosestKey(currentKey) {
      return getClosestOfKeys(this.getSortedKeys(), currentKey);
    }
  }, {
    key: "evaluate",
    value: function evaluate(ctx) {
      return this.value[this.getClosestKey(ctx.params.size)].evaluate(ctx);
    }
  }]);
  return AdaptiveProjection;
}();